// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__S3qLS","load5":"Spinner_load5__5weeu"};